const data = {
  Fashion: [
    {
      id: "1",
      name: "Men Regular Tshirt",
      price: 1400,
      image:
        "https://images.pexels.com/photos/1232459/pexels-photo-1232459.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      desc:
        "MixedBlue casual T-shirt, has a spread collar, button placket, 1 pocket, long sleeves, curved hem Manufacturer Info: Sixth Sense Country of Origin: India",
      rating: "45,000 Ratings & 12,000 Review",
      originalprice: "1500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: "2",
      name: "Fashion Regular Fit",
      price: 1100,
      image:
        "https://images.pexels.com/photos/1043148/pexels-photo-1043148.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      desc:
        " Simple Light Blue casual shirt, has a spread collar, button placket, 1 pocket, long sleeves, curved hem Manufacturer Info: Sixth Sense Country of Origin: India",
      rating: "4,000 Ratings & 2,000 Review",
      originalprice: 1200,
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
    },
    {
      id: "3",
      name: "Ultra Regular Fit",
      price: 300,
      image:
        "https://images.pexels.com/photos/769733/pexels-photo-769733.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      desc:
        "Red and black checked casual shirt, has a spread collar, button placket, 1 pocket, long sleeves, curved hem Manufacturer Info: Sixth Sense Country of Origin: India",
      rating: "45,000 Ratings & 12,000 Review",
      originalprice: 350,
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
    },
    {
      id: "4",
      name: "Regular Tshirt",
      price: 145,
      image:
        "https://images.pexels.com/photos/2769297/pexels-photo-2769297.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
      desc:
        " White casual T-shirt, has a spread collar, button placket, 1 pocket, long sleeves, curved hem Manufacturer Info: Sixth Sense Country of Origin: India",
      rating: "4500 Ratings & 1200 Review",
      originalprice: 165,
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
    },
    {
      id: "5",
      name: "Mixed Tshirt",
      price: 865,
      image:
        "https://images.pexels.com/photos/3193731/pexels-photo-3193731.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      desc:
        "Dark blue 33 casual T-shirt, has a spread collar, button placket, 1 pocket, long sleeves, curved hem Manufacturer Info: Sixth Sense Country of Origin: India",
      rating: "50 Ratings ",
      originalprice: 1200,
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
    },
    {
      id: "6",
      name: "Men Sharuk Fit",
      price: 899,
      image:
        "https://images.pexels.com/photos/1043474/pexels-photo-1043474.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      desc:
        "Coat with shirt for formals, has a spread collar, button placket, 1 pocket, long sleeves, curved hem Manufacturer Info: Sixth Sense Country of Origin: India",
      rating: "5,000 Ratings & 1,000 Review",
      originalprice: 999,
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer10% Unlimited Cashback on Fashin.in Card. ",
        <br></br>,
      ],
    },
    {
      id: "7",
      name: "Men Fit",
      price: 1600,
      image:
        "https://images.pexels.com/photos/594610/pexels-photo-594610.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      desc:
        "Green and Sandel casual Hoodie shirt, has a spread collar, button placket, 1 pocket, long sleeves, curved hem Manufacturer Info: Sixth Sense Country of Origin: India",
      rating: "1234 Ratings & 249 Review",
      originalprice: 1900,
      availableoffer: [
        "Bank Offer 15% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
    },
    {
      id: "8",
      name: "Men Regular",
      price: 2000,
      image:
        "https://images.pexels.com/photos/1486058/pexels-photo-1486058.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      desc:
        "White and Blue casual shirt, has a spread collar, button placket, 1 pocket, long sleeves, curved hem Manufacturer Info: Sixth Sense Country of Origin: India",
      rating: "489 Ratings & 12,000 Review",
      originalprice: 2900,
      availableoffer: [
        "Bank Offer25% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "0 % EMI on fashion.in card. ",
        <br></br>,
      ],
    },
    {
      id: "9",
      name: "Men Regular",
      price: 543,
      image:
        "https://images.pexels.com/photos/3026283/pexels-photo-3026283.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      desc:
        "Black with King casual T-shirt, has a spread collar, button placket, 1 pocket, long sleeves, curved hem Manufacturer Info: Sixth Sense Country of Origin: India",
      rating: "70 Ratings & 12 Review",
      originalprice: 894,
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
    },
    {
      id: "10",
      name: "Men Regular Tshirt",
      price: 233,
      image:
        "https://images.pexels.com/photos/2698844/pexels-photo-2698844.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
      desc:
        "Sandal casual T-shirt, has a spread collar, button placket, 1 pocket, long sleeves, curved hem Manufacturer Info: Sixth Sense Country of Origin: India",
      rating: "459 Ratings & 122 Review",
      originalprice: 300,
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
    },
  ],

  //HouseHold Products

  Grocery: [
    {
      id: 1,
      name: "SurfExcel Washing Powder",
      price: 200,
      originalprice: 250,
      image:
        "https://images-na.ssl-images-amazon.com/images/I/41FyJhx-%2B7L._SY450_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: 2,
      name: "Ariel Washing Powder",
      price: 300,
      originalprice: 350,
      image:
        "https://images-na.ssl-images-amazon.com/images/I/716fMToQlxL._SX466_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: 3,
      name: "Dettol Sanitiser",
      price: 120,
      originalprice: 150,
      image:
        "https://images-static.nykaa.com/media/catalog/product/8/9/8901396381501_new_1_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: 4,
      name: "Rin Detergent Bar",
      price: 299,
      originalprice: 358,
      image:
        "https://images-na.ssl-images-amazon.com/images/I/716fMToQlxL._SX466_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: 5,
      name: "SurfExcel Washing Powder",
      price: 450,
      originalprice: 850,
      image:
        "https://images-na.ssl-images-amazon.com/images/I/61gHH5yLxTL._SL1000_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: 6,
      name: "SurfExcel Detergent Bar",
      price: 200,
      originalprice: 250,
      image:
        "https://images-na.ssl-images-amazon.com/images/I/41FyJhx-%2B7L._SY450_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: 7,
      name: "Vanish",
      price: 400,
      originalprice: 250,
      image:
        "https://images-na.ssl-images-amazon.com/images/I/51dIOa3fuJL._SL1000_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: 8,
      brand: "SurfExcel",
      name: "Washing Powder",
      price: 100,
      originalprice: 250,
      image:
        "https://images-na.ssl-images-amazon.com/images/I/61gHH5yLxTL._SL1000_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: 9,
      name: "Rin Lemon ",
      price: 99,
      originalprice: 199,
      image:
        "https://images-na.ssl-images-amazon.com/images/I/61iB9z4PQNL._SX466_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: 10,
      name: "Comfort After ",
      price: 120,
      originalprice: 250,
      image:
        "https://images-na.ssl-images-amazon.com/images/I/610h%2BcTerLL._SY450_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: 11,
      name: "Dettol Sanitiser",
      price: 200,
      originalprice: 250,
      image:
        "https://images-static.nykaa.com/media/catalog/product/8/9/8901396381501_new_1_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
    {
      id: 12,
      name: "Rin Detergent Bar",
      price: 200,
      originalprice: 250,
      image:
        "https://images-na.ssl-images-amazon.com/images/I/716fMToQlxL._SX466_.jpg",
      desc: "This is SurfExcel Washing powder. It is powerful.",
      rating: "45,000 Ratings & 12,000 Review",
      weight: "Weight : 500g",
      availableoffer: [
        "* Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "* 0% Cost EMI on Fashion.in Card ",
        <br></br>,
        "* Unlimited Cashback on Credit Card. ",
        <br></br>,
      ],
      termscondition: "* TERMS AND CONDITION *",
    },
  ],

  mobiles: [
    {
      id: 1,
      name: "samsung Galaxy F41",
      rating: "45,000 Ratings & 12,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/312/312/kfzq8i80/mobile/y/j/f/samsung-galaxy-f41-sm-f415fzbdins-original-imafwbnpdafmeuj6.jpeg?q=70",
      memory: "64 GB",
      ram: "6 GB",
      price: "15500",
      originalprice: "17500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },

    {
      id: 2,
      name: "Poco X3",
      rating: "4,000 Ratings & 2,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/312/312/kfbfr0w0/mobile/f/x/r/poco-x3-mzb07z2in-original-imafvt3hz54npsba.jpeg?q=70",
      memory: "64 GB",
      ram: "6 GB",
      price: "15500",
      originalprice: "17500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 3,
      name: "Realme 7",
      rating: "4,000 Ratings & 2,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/312/312/keiuxzk0/mobile/z/h/3/realme-7-rmx2151-original-imafv7fzhnxkmdhx.jpeg?q=70",
      memory: "64 GB",
      ram: "6 GB",
      price: "15500",
      originalprice: "17500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 4,
      name: "Narzo",
      rating: "4,000 Ratings & 2,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/312/312/kfbfr0w0/mobile/s/t/p/realme-narzo-20-rmx2193-original-imafvsw7vfqzh6wr.jpeg?q=70",
      memory: "64 GB",
      ram: "6 GB",
      price: "15500",
      originalprice: "17500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 5,
      name: "Infinix Smart HD",
      rating: "4,000 Ratings & 2,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/312/312/kiow6fk0/mobile/z/s/y/infinix-smart-hd-2021-x612b-original-imafyf9f2xuxh8zr.jpeg?q=70",
      memory: "64 GB",
      ram: "6 GB",
      price: "15500",
      originalprice: "17500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 6,
      name: "Iphone 12",
      rating: "4,000 Ratings & 2,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/312/312/kg8avm80/mobile/p/f/w/apple-iphone-12-dummyapplefsn-original-imafwg8dqjuq8sug.jpeg?q=70",
      memory: "64 GB",
      ram: "6 GB",
      price: "15500",
      originalprice: "17500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
  ],
  Televison: [
    {
      id: 1,
      name: "MI 4K Tv",
      rating: "4,000 Ratings & 2,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/416/416/kc54ivk0/television/y/c/u/mi-l50m5-5ain-original-imaftc5fzuhfdvzm.jpeg?q=70",
      displysize: "50 Inch",
      disply: "4K",
      OS: "Android",
      price: "33500",
      originalprice: "40500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 2,
      name: "Panasonic 55 Inch UHD",
      rating: "4,000 Ratings & 2,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/416/416/keuagsw0/television/y/e/y/panasonic-th-50hx450dx-th-50hx450dx-original-imafvf3sbzgzygu2.jpeg?q=70",
      displysize: "55 Inch",
      disply: "4K",
      OS: "Android",
      price: "33500",
      originalprice: "40500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 3,
      name: "LG ThinQ",
      rating: "4,000 Ratings & 2,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/416/416/kljrvrk0/television/f/6/3/50um7290ptd-lg-original-imagynhfa5cwfhkf.jpeg?q=70",
      displysize: "50 Inch",
      disply: "4K",
      OS: "Android",
      price: "33500",
      originalprice: "40500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 4,
      name: "Thomson",
      rating: "4,000 Ratings & 2,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/416/416/kjrh2fk0/television/w/u/f/50-oathpro-1212-50oathpro1212-thomson-original-imafz9gsgcghzfcd.jpeg?q=70",
      displysize: "50 Inch",
      disply: "4K UHD",
      OS: "Android",
      price: "33500",
      originalprice: "40500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 5,
      name: "Nokia UltraHD",
      image:
        "https://rukminim1.flixcart.com/image/416/416/kfwvcsw0/television/g/4/u/nokia-50tauhdn-original-imafw8xggpjge2hk.jpeg?q=70",
      displysize: "50 Inch",
      disply: "4K UHD",
      OS: "Android",
      price: "38500",
      rating: "4,000 Ratings & 2,000 Review",
      originalprice: "45890",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 6,
      name: "Kodak 50Inch",
      image:
        "https://rukminim1.flixcart.com/image/416/416/kjiwfbk0-0/television/c/x/p/50ca7077-kodak-original-imafz2hfsh5hxfgm.jpeg?q=70",
      displysize: "50 Inch",
      disply: "4K",
      OS: "Android",
      price: "33500",
      rating: "4,000 Ratings & 2,000 Review",
      originalprice: "40500",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
  ],
  Homeappliances: [
    {
      id: 1,
      name: "Double Cartoon Bedsheet",
      image:
        "https://rukminim1.flixcart.com/image/416/416/k6gsk280/bedsheet/v/h/t/lion-kitty-cartoon-cartoon-bedsheet-112-flat-shivi-creation-original-imafk8h83zjwvcuw.jpeg?q=70",
      price: "500",
      originalprice: "780",
      rating: "4,000 Ratings & 2,000 Review",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 2,
      name: "LooMantha Rectangular",
      image:
        "https://rukminim1.flixcart.com/image/416/416/kfmv9u80/table-placemat/g/v/g/l-3-table-placemat-loomantha-original-imafwfz8abhyc9mh.jpeg?q=70",
      price: "200",
      rating: "4,000 Ratings & 2,000 Review",
      originalprice: "400",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 3,
      name: "Cotton Hand Towel",
      image:
        "https://rukminim1.flixcart.com/image/416/416/k6tniq80/bath-towel/5/g/4/joy-hand-towel-set-joy-ntjo00008-nandan-joy-original-imafp6y653ghjnhy.jpeg?q=70",
      price: "340",
      rating: "4,000 Ratings & 2,000 Review",
      originalprice: "599",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 4,
      rating: "4,000 Ratings & 2,000 Review",
      name: " Cotton Bedsheet",
      image:
        "https://rukminim1.flixcart.com/image/416/416/k0463rk0/bedsheet/n/f/u/designer-cb1526-flat-iws-original-imafjz94uzankupg.jpeg?q=70",
      price: "335",
      originalprice: "405",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 5,
      name: "Double Bedsheet",
      rating: "4,000 Ratings & 2,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/416/416/bedsheet/w/c/s/sgh-1007-sgh-fitted-flat-sgh-1007-original-imaeeah3yphnk9fx.jpeg?q=70",
      price: "290",
      originalprice: "450",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
    {
      id: 6,
      name: "Musquito Net",
      rating: "4,000 Ratings & 2,000 Review",
      image:
        "https://rukminim1.flixcart.com/image/416/416/khtghow0/mosquito-net/t/y/a/blue-mosquito-net-polyester-adults-net-king-size-double-bed-original-imafxqn3uqzdhgey.jpeg?q=70",
      price: "890",
      originalprice: "1200",
      availableoffer: [
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
        "Bank Offer5% Unlimited Cashback on Axis Bank Credit Card. ",
        <br></br>,
      ],
      desc:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Non fugit ipsa facere repellendus eveniet, ducimus, corporis nisi inventore porro possimus praesentium? Labore officiis unde consectetur! Dolor doloribus assumenda iure eum.",
    },
  ],
};

export default data;
